import { projectActions } from '../store/reducers/projectReducer';

export class DbTypeService {
    public static $inject = ['store', 'sessionService'];

    private store: any;
    private sessionService: any;

    constructor(store: any, sessionService: any) {
        this.sessionService = sessionService;
        this.store = store;
    }

    public async getFlags(dbTypeId: any) {
        if (this.store.getState().project.dbTypeFlags && this.store.getState().project.dbTypeFlags[dbTypeId]) {
            return this.store.getState().project.dbTypeFlags[dbTypeId];
        }
        const action = { type: projectActions.GET_DB_TYPE_FLAGS, payload: { dbTypeId } };
        return await this.store.dispatch(action).then((response: any) => {
            if (response.data) {
                return response.data;
            }
        });
    }

    public async prepareDbTypesImages(dbTypes: any) {
        const dbTypeImagePromisses = [];
        if (this.shouldFetchImages(dbTypes)) {
            dbTypes.forEach((dbType: any) => {
                dbTypeImagePromisses.push(this.fetchDbTypeImage(dbType.key));
            });
            await Promise.all(dbTypeImagePromisses)
                .then(dbTypeImages =>
                    dbTypeImages.forEach((dbTypeImage, index) =>
                        this.storeImageInLocalStorage(dbTypes[index].key, dbTypeImage)));
        }
    }

    public shouldFetchImages(dbTypes: any) {
        return !dbTypes.some((dbType : any) => this.getDbTypeImageFromLocalStorage(dbType.key) ? true : false);
    }

    public fetchDbTypeImage(dbTypeId: any) {
        const action = { type: projectActions.GET_DB_TYPE_IMAGE, payload: { dbTypeId } };
        return this.store.dispatch(action).then((response: any) => {
            if (response.data) {
                return response.data;
            }
        });
    }

    public getDbTypeImageFromLocalStorage(dbTypeId: any) {
        return this.sessionService.get(this.getLocalStorageImageKey(dbTypeId));
    }

    public storeImageInLocalStorage(dbTypeId: any, dbTypeImage: any) {
        this.sessionService.set(this.getLocalStorageImageKey(dbTypeId), dbTypeImage);
    }

    public getLocalStorageImageKey(dbTypeId: any) {
        return `dbTypeImage-${dbTypeId}-v${window.__env.config.versionRM}`;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/services/dbTypeService.ts